/**
 * @fileoverview Array.prototype.at polyfill
 * FIXME (@mossymaker): remove when the browser version requirement lines up
 * with https://caniuse.com/mdn-javascript_builtins_array_at
 */
if (![].at)
  Array.prototype.at = function (index) {
    return this.slice(index, index !== -1 ? index + 1 : undefined)[0];
  };
